var map = {
	"./Screenshot 2024-08-13 at 8.36.13 pm.png": 2731,
	"./Screenshot 2024-08-13 at 8.38.12 pm.png": 4346,
	"./Screenshot 2024-08-13 at 8.38.54 pm.png": 5564,
	"./Screenshot 2024-08-13 at 9.20.03 pm.png": 6716,
	"./Screenshot 2024-08-13 at 9.20.12 pm.png": 510,
	"./Screenshot 2024-08-13 at 9.21.04 pm.png": 9104,
	"./Screenshot 2024-08-13 at 9.21.48 pm.png": 8264,
	"./Screenshot 2024-08-13 at 9.22.01 pm.png": 452,
	"./Screenshot 2024-08-13 at 9.27.17 pm.png": 6870,
	"./Screenshot 2024-08-13 at 9.28.26 pm.png": 4885,
	"./Screenshot 2024-08-13 at 9.29.58 pm.png": 217,
	"./Screenshot 2024-08-13 at 9.31.38 pm.png": 3132,
	"./Screenshot 2024-08-13 at 9.32.37 pm.png": 1958,
	"./Screenshot 2024-08-13 at 9.34.33 pm.png": 3552,
	"./Screenshot 2024-08-20 at 7.40.32 pm.png": 8178,
	"./review1.jpg": 6639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2370;